import printerSettings from './printerSettings';
import generalSettings from './restauranSettings/generalSettings';

export default {
  printerSettings,
  generalSettings,
};
